import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Translator } from '../../../types';
import Calendar from '../Calendar/Calendar';
import Modal from '../schedulemodal/Schedulemodal';
import style from './WorkScheduleForm.module.css';
import CrossIcon from './icons/Сross';
import { fetchTranslatorData } from './workScheduleHelpers';

interface WorkScheduleFormProps {
  translatorId: string;
  translatorName: string;
  onSave: (id: string, schedule: Translator['weeklyWorkSchedule']) => void;
  onClose: () => void;
  onRefresh: () => void;
}

const WorkScheduleForm: React.FC<WorkScheduleFormProps> = ({
  translatorId,
  translatorName,
  onClose,
  onRefresh,
}) => {
  const [updateCounter, setUpdateCounter] = useState<number>(0);
  const dispatch = useDispatch();

  useEffect(() => {
    fetchTranslatorData(translatorId, dispatch);
  }, [translatorId, dispatch, updateCounter]);

  // Розклад зберігається наживо: вибір часу по дню та «Заповнити за шаблоном»
  // обидва пишуть у PUT /Admin/Schedule. «Готово» лише оновлює список і закриває.
  const handleDone = () => {
    onRefresh();
    onClose();
  };

  return (
    <Modal isOpen={true} onClose={onClose}>
      {translatorId && (
        <>
          <div className={style.title}>
            <h4>Графік роботи: {translatorName}</h4>
            <button className={style.closeButton} onClick={onClose}>
              <CrossIcon />
            </button>
          </div>
          <div className={style.calendarContainer}>
            <Calendar
              userId={translatorId}
              updateCounter={updateCounter}
              setUpdateCounter={setUpdateCounter}
            />
          </div>
          <div className={style.saveButtonContainer}>
            <button onClick={handleDone} className={style.saveButton}>
              Готово
            </button>
          </div>
        </>
      )}
    </Modal>
  );
};

export default WorkScheduleForm;
